import { ColWidth } from "@/constants/common.constant";
import { TableHeaderConfig } from "@/interfaces/common.interface";

export const VIEW_NAME = "申請分類";

export interface ShinseiBunruiInfo {
  id: number;
  shinseiBunruiCd: string;
  shinseiBunruiNm: string;
  createdDate: string;
  updatedDate: string;
}

export const Prop2LabelMap = {
  id: "ID",
  shinseiBunruiCd: "申請分類コード",
  shinseiBunruiNm: "申請分類名",
  createdDate: "登録日時",
  updatedDate: "更新日時",
};

export const tableConfig: TableHeaderConfig[] = [
  {
    prop: "shinseiBunruiCd",
    label: Prop2LabelMap.shinseiBunruiCd,
    width: ColWidth.md,
  },
  {
    prop: "shinseiBunruiNm",
    label: Prop2LabelMap.shinseiBunruiNm,
    width: ColWidth.xl,
  },
  {
    prop: "createdDate",
    label: Prop2LabelMap.createdDate,
    width: ColWidth.lg,
  },
  {
    prop: "updatedDate",
    label: Prop2LabelMap.updatedDate,
    width: ColWidth.lg,
  },
];
